// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__1CgXu","black":"button_black__2QIFq","white":"button_white__3zlse"};